import { formatNumberWithCommas, formatNumberWithCommasEliminateDecimal } from '../../utils';

const StatisTable = ({ statis, statisTicket }) => {
    return (
        <>
            <tr>
                <th>기본광고</th>
                <th>구인등록</th>
                <td>{formatNumberWithCommas(statis?.qty001Dental + statis?.qty001DvMall || '-')}</td>
                <td>{formatNumberWithCommas(statis?.qty001Dental || '-')}</td>
                <td>{formatNumberWithCommas(statis?.qty001DvMall || '-')}</td>
                <td>{formatNumberWithCommasEliminateDecimal(statis?.total001 || '-')}</td>
                <td>{formatNumberWithCommasEliminateDecimal(statisTicket?.totalCount001 || '-')}</td>
                <td>-</td>
                <td>{formatNumberWithCommas(statisTicket?.usedCount001 || '-')}</td>
                <td>{formatNumberWithCommas(statisTicket?.unusedCount001 || '-')}</td>
                <td>{formatNumberWithCommasEliminateDecimal(statisTicket?.totalAmount001 || '-')}</td>
            </tr>
            <tr>
                <th rowSpan={3}>배너</th>
                <th>그랜드</th>
                <td>{formatNumberWithCommas(statis?.qty002Dental + statis?.qty002DvMall || '-')}</td>
                <td>{formatNumberWithCommas(statis?.qty002Dental || '-')}</td>
                <td>{formatNumberWithCommas(statis?.qty002DvMall || '-')}</td>
                <td>{formatNumberWithCommasEliminateDecimal(statis?.total002 || '-')}</td>
                <td>{formatNumberWithCommasEliminateDecimal(statisTicket?.totalCount002 || '-')}</td>
                <td>-</td>
                <td>{formatNumberWithCommas(statisTicket?.usedCount002 || '-')}</td>
                <td>{formatNumberWithCommas(statisTicket?.unusedCount002 || '-')}</td>
                <td>{formatNumberWithCommasEliminateDecimal(statisTicket?.totalAmount002 || '-')}</td>
            </tr>
            <tr>
                <th>프리미엄</th>
                <td>{formatNumberWithCommas(statis?.qty003Dental + statis?.qty003DvMall || '-')}</td>
                <td>{formatNumberWithCommas(statis?.qty003Dental || '-')}</td>
                <td>{formatNumberWithCommas(statis?.qty003DvMall || '-')}</td>
                <td>{formatNumberWithCommasEliminateDecimal(statis?.total003 || '-')}</td>
                <td>{formatNumberWithCommasEliminateDecimal(statisTicket?.totalCount003 || '-')}</td>
                <td>-</td>
                <td>{formatNumberWithCommas(statisTicket?.usedCount003 || '-')}</td>
                <td>{formatNumberWithCommas(statisTicket?.unusedCount003 || '-')}</td>
                <td>{formatNumberWithCommasEliminateDecimal(statisTicket?.totalAmount003 || '-')}</td>
            </tr>
            <tr>
                <th>핫리쿠르트</th>
                <td>{formatNumberWithCommas(statis?.qty008Dental + statis?.qty008DvMall || '-')}</td>
                <td>{formatNumberWithCommas(statis?.qty008Dental || '-')}</td>
                <td>{formatNumberWithCommas(statis?.qty008DvMall || '-')}</td>
                <td>{formatNumberWithCommasEliminateDecimal(statis?.total008 || '-')}</td>
                <td>{formatNumberWithCommasEliminateDecimal(statisTicket?.totalCount008 || '-')}</td>
                <td>-</td>
                <td>{formatNumberWithCommas(statisTicket?.usedCount008 || '-')}</td>
                <td>{formatNumberWithCommas(statisTicket?.unusedCount008 || '-')}</td>
                <td>{formatNumberWithCommasEliminateDecimal(statisTicket?.totalAmount008 || '-')}</td>
            </tr>
            <tr>
                <th rowSpan={4}>고정옵션</th>
                <th>고정-채용소식</th>
                <td>
                    {formatNumberWithCommas(
                        statis?.qty5000Dental + statis?.qty5002Dental + statis?.qty5000DvMall + statis?.qty5002DvMall ||
                            '-',
                    )}
                </td>
                <td>{formatNumberWithCommas(statis?.qty5000Dental + statis?.qty5002Dental || '-')}</td>
                <td>{formatNumberWithCommas(statis?.qty5000DvMall + statis?.qty5002DvMall || '-')}</td>
                <td>{formatNumberWithCommasEliminateDecimal(statis?.total5000 + statis?.total5002 || '-')}</td>
                <td>
                    {formatNumberWithCommasEliminateDecimal(
                        statisTicket?.totalCount5000 + statisTicket?.totalCount5002 || '-',
                    )}
                </td>
                <td>-</td>
                <td>{formatNumberWithCommas(statisTicket?.usedCount5000 + statisTicket?.usedCount5002 || '-')}</td>
                <td>{formatNumberWithCommas(statisTicket?.unusedCount5000 + statisTicket?.unusedCount5002 || '-')}</td>
                <td>
                    {formatNumberWithCommasEliminateDecimal(
                        statisTicket?.totalAmount5000 + statisTicket?.totalAmount5002 || '-',
                    )}
                </td>
            </tr>
            <tr>
                <th>고정-그랜드</th>
                <td>{formatNumberWithCommas(statis?.qty6000Dental + statis?.qty6000DvMall || '-')}</td>
                <td>{formatNumberWithCommas(statis?.qty6000Dental || '-')}</td>
                <td>{formatNumberWithCommas(statis?.qty6000DvMall || '-')}</td>
                <td>{formatNumberWithCommasEliminateDecimal(statis?.total6000 || '-')}</td>
                <td>{formatNumberWithCommasEliminateDecimal(statisTicket?.totalCount6000 || '-')}</td>
                <td>-</td>
                <td>{formatNumberWithCommas(statisTicket?.usedCount6000 || '-')}</td>
                <td>{formatNumberWithCommas(statisTicket?.unusedCount6000 || '-')}</td>
                <td>{formatNumberWithCommasEliminateDecimal(statisTicket?.totalAmount6000 || '-')}</td>
            </tr>
            <tr>
                <th>고정-프리미엄</th>
                <td>{formatNumberWithCommas(statis?.qty7000Dental + statis?.qty7000DvMall || '-')}</td>
                <td>{formatNumberWithCommas(statis?.qty7000Dental || '-')}</td>
                <td>{formatNumberWithCommas(statis?.qty7000DvMall || '-')}</td>
                <td>{formatNumberWithCommasEliminateDecimal(statis?.total7000 || '-')}</td>
                <td>{formatNumberWithCommasEliminateDecimal(statisTicket?.totalCount7000 || '-')}</td>
                <td>-</td>
                <td>{formatNumberWithCommas(statisTicket?.usedCount7000 || '-')}</td>
                <td>{formatNumberWithCommas(statisTicket?.unusedCount7000 || '-')}</td>
                <td>{formatNumberWithCommasEliminateDecimal(statisTicket?.totalAmount7000 || '-')}</td>
            </tr>
            <tr>
                <th>고정-핫리쿠르트</th>
                <td>{formatNumberWithCommas(statis?.qty4000Dental + statis?.qty4000DvMall || '-')}</td>
                <td>{formatNumberWithCommas(statis?.qty4000Dental || '-')}</td>
                <td>{formatNumberWithCommas(statis?.qty4000DvMall || '-')}</td>
                <td>{formatNumberWithCommasEliminateDecimal(statis?.total4000 || '-')}</td>
                <td>{formatNumberWithCommasEliminateDecimal(statisTicket?.totalCount4000 || '-')}</td>
                <td>-</td>
                <td>{formatNumberWithCommas(statisTicket?.usedCount4000 || '-')}</td>
                <td>{formatNumberWithCommas(statisTicket?.unusedCount4000 || '-')}</td>
                <td>{formatNumberWithCommasEliminateDecimal(statisTicket?.totalAmount4000 || '-')}</td>
            </tr>
            <tr>
                <th rowSpan={6}>강조상품</th>
                <th>하이라이트- 1주</th>
                <td>{formatNumberWithCommas(statis?.qty1000Dental + statis?.qty1000DvMall || '-')}</td>
                <td>{formatNumberWithCommas(statis?.qty1000Dental || '-')}</td>
                <td>{formatNumberWithCommas(statis?.qty1000DvMall || '-')}</td>
                <td>{formatNumberWithCommasEliminateDecimal(statis?.total1000 || '-')}</td>
                <td>{formatNumberWithCommasEliminateDecimal(statisTicket?.totalCount1000 || '-')}</td>
                <td>-</td>
                <td>{formatNumberWithCommas(statisTicket?.usedCount1000 || '-')}</td>
                <td>{formatNumberWithCommas(statisTicket?.unusedCount1000 || '-')}</td>
                <td>{formatNumberWithCommasEliminateDecimal(statisTicket?.totalAmount1000 || '-')}</td>
            </tr>

            <tr>
                <th>하이라이트- 2주</th>
                <td>{formatNumberWithCommas(statis?.qty1500Dental + statis?.qty1500DvMall || '-')}</td>
                <td>{formatNumberWithCommas(statis?.qty1500Dental || '-')}</td>
                <td>{formatNumberWithCommas(statis?.qty1500DvMall || '-')}</td>
                <td>{formatNumberWithCommasEliminateDecimal(statis?.total1500 || '-')}</td>
                <td>{formatNumberWithCommasEliminateDecimal(statisTicket?.totalCount1500 || '-')}</td>
                <td>-</td>
                <td>{formatNumberWithCommas(statisTicket?.usedCount1500 || '-')}</td>
                <td>{formatNumberWithCommas(statisTicket?.unusedCount1500 || '-')}</td>
                <td>{formatNumberWithCommasEliminateDecimal(statisTicket?.totalAmount1500 || '-')}</td>
            </tr>
            <tr>
                <th>컬러- 1주</th>
                <td>{formatNumberWithCommas(statis?.qty2000Dental + statis?.qty2000DvMall || '-')}</td>
                <td>{formatNumberWithCommas(statis?.qty2000Dental || '-')}</td>
                <td>{formatNumberWithCommas(statis?.qty2000DvMall || '-')}</td>
                <td>{formatNumberWithCommasEliminateDecimal(statis?.total2000 || '-')}</td>
                <td>{formatNumberWithCommasEliminateDecimal(statisTicket?.totalCount2000 || '-')}</td>
                <td>-</td>
                <td>{formatNumberWithCommas(statisTicket?.usedCount2000 || '-')}</td>
                <td>{formatNumberWithCommas(statisTicket?.unusedCount2000 || '-')}</td>
                <td>{formatNumberWithCommasEliminateDecimal(statisTicket?.totalAmount2000 || '-')}</td>
            </tr>
            <tr>
                <th>컬러- 2주</th>
                <td>{formatNumberWithCommas(statis?.qty2500Dental + statis?.qty2500DvMall || '-')}</td>
                <td>{formatNumberWithCommas(statis?.qty2500Dental || '-')}</td>
                <td>{formatNumberWithCommas(statis?.qty2500DvMall || '-')}</td>
                <td>{formatNumberWithCommasEliminateDecimal(statis?.total2500 || '-')}</td>
                <td>{formatNumberWithCommasEliminateDecimal(statisTicket?.totalCount2500 || '-')}</td>
                <td>-</td>
                <td>{formatNumberWithCommas(statisTicket?.usedCount2500 || '-')}</td>
                <td>{formatNumberWithCommas(statisTicket?.unusedCount2500 || '-')}</td>
                <td>{formatNumberWithCommasEliminateDecimal(statisTicket?.totalAmount2500 || '-')}</td>
            </tr>
            <tr>
                <th>아이콘- 1주</th>
                <td>
                    {formatNumberWithCommas(
                        statis?.qty3010Dental + statis?.qty3020Dental + statis?.qty3010DvMall + statis?.qty3020DvMall ||
                            '-',
                    )}
                </td>
                <td>{formatNumberWithCommas(statis?.qty3010Dental + statis?.qty3020Dental || '-')}</td>
                <td>{formatNumberWithCommas(statis?.qty3010DvMall + statis?.qty3020DvMall || '-')}</td>
                <td>{formatNumberWithCommasEliminateDecimal(statis?.total3010 + statis?.total3020 || '-')}</td>
                <td>
                    {formatNumberWithCommasEliminateDecimal(
                        statisTicket?.totalCount3010 + statisTicket?.totalCount3020 || '-',
                    )}
                </td>
                <td>-</td>
                <td>{formatNumberWithCommas(statisTicket?.usedCount3010 + statisTicket?.usedCount3020 || '-')}</td>
                <td>{formatNumberWithCommas(statisTicket?.unusedCount3010 + statisTicket?.unusedCount3020 || '-')}</td>
                <td>
                    {formatNumberWithCommasEliminateDecimal(
                        statisTicket?.totalAmount3010 + statisTicket?.totalAmount3020 || '-',
                    )}
                </td>
            </tr>
            <tr>
                <th>아이콘- 2주</th>
                <td>
                    {formatNumberWithCommas(
                        statis?.qty3510Dental + statis?.qty3520Dental + statis?.qty3510DvMall + statis?.qty3520DvMall ||
                            '-',
                    )}
                </td>
                <td>{formatNumberWithCommas(statis?.qty3510Dental + statis?.qty3520Dental || '-')}</td>
                <td>{formatNumberWithCommas(statis?.qty3510DvMall + statis?.qty3520DvMall || '-')}</td>
                <td>{formatNumberWithCommasEliminateDecimal(statis?.total3510 + statis?.total3520 || '-')}</td>
                <td>
                    {formatNumberWithCommasEliminateDecimal(
                        statisTicket?.totalCount3510 + statisTicket?.totalCount3520 || '-',
                    )}
                </td>
                <td>-</td>
                <td>{formatNumberWithCommas(statisTicket?.usedCount3510 + statisTicket?.usedCount3520 || '-')}</td>
                <td>{formatNumberWithCommas(statisTicket?.unusedCount3510 + statisTicket?.unusedCount3520 || '-')}</td>
                <td>
                    {formatNumberWithCommasEliminateDecimal(
                        statisTicket?.totalAmount3510 + statisTicket?.totalAmount3520 || '-',
                    )}
                </td>
            </tr>

            <tr>
                <th colSpan={2}>일반기업 배너</th>
                <td>{formatNumberWithCommas(statis?.qty010Dental || '-')}</td>
                <td>{formatNumberWithCommas(statis?.qty010Dental || '-')}</td>
                <td>-</td>
                <td>{formatNumberWithCommasEliminateDecimal(statis?.total010 || '-')}</td>
                <td>{formatNumberWithCommasEliminateDecimal(statisTicket?.totalCount010 || '-')}</td>
                <td>-</td>
                <td>{formatNumberWithCommas(statisTicket?.usedCount010 || '-')}</td>
                <td>{formatNumberWithCommas(statisTicket?.unusedCount010 || '-')}</td>
                <td>{formatNumberWithCommasEliminateDecimal(statisTicket?.totalAmount010 || '-')}</td>
            </tr>
            <tr>
                <th colSpan={2}>덴탈알바</th>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
            </tr>
            <tr>
                <th colSpan={2}>총계</th>
                <td>-</td>
                <td>
                    {formatNumberWithCommasEliminateDecimal(
                        statis?.qty001Dental +
                            statis?.qty002Dental +
                            statis?.qty003Dental +
                            statis?.qty008Dental +
                            statis?.qty5000Dental +
                            statis?.qty5002Dental +
                            statis?.qty6000Dental +
                            statis?.qty7000Dental +
                            statis?.qty4000Dental +
                            statis?.qty1000Dental +
                            statis?.qty1500Dental +
                            statis?.qty2000Dental +
                            statis?.qty2500Dental +
                            statis?.qty3010Dental +
                            statis?.qty3020Dental +
                            statis?.qty3510Dental +
                            statis?.qty3520Dental +
                            statis?.qty010Dental || '-',
                    )}
                </td>
                <td>
                    {formatNumberWithCommasEliminateDecimal(
                        statis?.qty001DvMall +
                            statis?.qty002DvMall +
                            statis?.qty003DvMall +
                            statis?.qty008DvMall +
                            statis?.qty5000DvMall +
                            statis?.qty5002DvMall +
                            statis?.qty6000DvMall +
                            statis?.qty7000DvMall +
                            statis?.qty4000DvMall +
                            statis?.qty1000DvMall +
                            statis?.qty1500DvMall +
                            statis?.qty2000DvMall +
                            statis?.qty2500DvMall +
                            statis?.qty3010DvMall +
                            statis?.qty3020DvMall +
                            statis?.qty3510DvMall +
                            statis?.qty3520DvMall +
                            statis?.qty010DvMall || '-',
                    )}
                </td>
                <td>
                    {formatNumberWithCommasEliminateDecimal(
                        statis?.total001 +
                            statis?.total002 +
                            statis?.total003 +
                            statis?.total008 +
                            statis?.total5000 +
                            statis?.total5002 +
                            statis?.total6000 +
                            statis?.total7000 +
                            statis?.total4000 +
                            statis?.total1000 +
                            statis?.total1500 +
                            statis?.total2000 +
                            statis?.total2500 +
                            statis?.total3010 +
                            statis?.total3020 +
                            statis?.total3510 +
                            statis?.total3520 +
                            statis?.total010 || '-',
                    )}
                </td>
                <td>
                    {formatNumberWithCommasEliminateDecimal(
                        (statisTicket?.totalCount001 || 0) +
                            (statisTicket?.totalCount002 || 0) +
                            (statisTicket?.totalCount003 || 0) +
                            (statisTicket?.totalCount008 || 0) +
                            (statisTicket?.totalCount010 || 0) +
                            (statisTicket?.totalCount5000 || 0) +
                            (statisTicket?.totalCount5002 || 0) +
                            (statisTicket?.totalCount6000 || 0) +
                            (statisTicket?.totalCount7000 || 0) +
                            (statisTicket?.totalCount4000 || 0) +
                            (statisTicket?.totalCount1000 || 0) +
                            (statisTicket?.totalCount1500 || 0) +
                            (statisTicket?.totalCount2000 || 0) +
                            (statisTicket?.totalCount2500 || 0) +
                            (statisTicket?.totalCount3010 || 0) +
                            (statisTicket?.totalCount3020 || 0) +
                            (statisTicket?.totalCount3510 || 0) +
                            (statisTicket?.totalCount3520 || 0) || '-',
                    )}
                </td>
                <td>-</td>
                <td>
                    {formatNumberWithCommasEliminateDecimal(
                        (statisTicket?.usedCount001 || 0) +
                            (statisTicket?.usedCount002 || 0) +
                            (statisTicket?.usedCount003 || 0) +
                            (statisTicket?.usedCount008 || 0) +
                            (statisTicket?.usedCount010 || 0) +
                            (statisTicket?.usedCount5000 || 0) +
                            (statisTicket?.usedCount5002 || 0) +
                            (statisTicket?.usedCount6000 || 0) +
                            (statisTicket?.usedCount7000 || 0) +
                            (statisTicket?.usedCount4000 || 0) +
                            (statisTicket?.usedCount1000 || 0) +
                            (statisTicket?.usedCount1500 || 0) +
                            (statisTicket?.usedCount2000 || 0) +
                            (statisTicket?.usedCount2500 || 0) +
                            (statisTicket?.usedCount3010 || 0) +
                            (statisTicket?.usedCount3020 || 0) +
                            (statisTicket?.usedCount3510 || 0) +
                            (statisTicket?.usedCount3520 || 0) || '-',
                    )}
                </td>
                <td>
                    {formatNumberWithCommasEliminateDecimal(
                        (statisTicket?.unusedCount001 || 0) +
                            (statisTicket?.unusedCount002 || 0) +
                            (statisTicket?.unusedCount003 || 0) +
                            (statisTicket?.unusedCount008 || 0) +
                            (statisTicket?.unusedCount010 || 0) +
                            (statisTicket?.unusedCount5000 || 0) +
                            (statisTicket?.unusedCount5002 || 0) +
                            (statisTicket?.unusedCount6000 || 0) +
                            (statisTicket?.unusedCount7000 || 0) +
                            (statisTicket?.unusedCount4000 || 0) +
                            (statisTicket?.unusedCount1000 || 0) +
                            (statisTicket?.unusedCount1500 || 0) +
                            (statisTicket?.unusedCount2000 || 0) +
                            (statisTicket?.unusedCount2500 || 0) +
                            (statisTicket?.unusedCount3010 || 0) +
                            (statisTicket?.unusedCount3020 || 0) +
                            (statisTicket?.unusedCount3510 || 0) +
                            (statisTicket?.unusedCount3520 || 0) || '-',
                    )}
                </td>
                <td>
                    {formatNumberWithCommasEliminateDecimal(
                        (statisTicket?.totalAmount001 || 0) +
                            (statisTicket?.totalAmount002 || 0) +
                            (statisTicket?.totalAmount003 || 0) +
                            (statisTicket?.totalAmount008 || 0) +
                            (statisTicket?.totalAmount010 || 0) +
                            (statisTicket?.totalAmount5000 || 0) +
                            (statisTicket?.totalAmount5002 || 0) +
                            (statisTicket?.totalAmount6000 || 0) +
                            (statisTicket?.totalAmount7000 || 0) +
                            (statisTicket?.totalAmount4000 || 0) +
                            (statisTicket?.totalAmount1000 || 0) +
                            (statisTicket?.totalAmount1500 || 0) +
                            (statisTicket?.totalAmount2000 || 0) +
                            (statisTicket?.totalAmount2500 || 0) +
                            (statisTicket?.totalAmount3010 || 0) +
                            (statisTicket?.totalAmount3020 || 0) +
                            (statisTicket?.totalAmount3510 || 0) +
                            (statisTicket?.totalAmount3520 || 0) || '-',
                    )}
                </td>
            </tr>
        </>
    );
};

export default StatisTable;
